import { Layout } from 'antd';
const { Footer } = Layout;

const AppFooter = () => {
    return (
        <Footer className='appFooter'>
            CNA © {new Date().getFullYear()}
        </Footer>
    );
}
export default AppFooter;